import { CaseDetail } from './CaseDetail'
import { NewlyHired, NewlyHiredApiData } from './newlyHired'

// Accept: Bruger kan accepter/"tage" sagen
// Afvis: Bruger kan afvise sagen
// SammenfletMedAndenSag: Bruger kan sammenflette sagen med en anden sag
// FjernSammenfletMedAndenSag: Bruger kan fjerne sammenfletning mellem denne sag og en anden sag
// Sagsbehandle: Bruger kan opdater nyansattes data, sagsbehandling og andre sagsdata på sagen, oprette/slette remindere og notater, uploade filer til sagen.
// Afslut: Bruger kan afslutte sagen/sagsbehandlingen.
// IngenHandling: Bruger kan ikke handle på sagen
export type AllowedUpdateActionList =
    | 'Accept'
    | 'Afvis'
    | 'SammenfletMedAndenSag'
    | 'FjernSammenfletMedAndenSag'
    | 'Sagsbehandle'
    | 'Afslut'
    | 'IngenHandling'

export interface CaseStatusApiData {
    statusNavn: string

    statusType: string

    visStatus: boolean
}

export class CaseStatus {
    statusNavn = ''

    statusType = ''

    visStatus = false

    static build(data: CaseStatusApiData): CaseStatus {
        const caseStatus = new CaseStatus()
        caseStatus.statusNavn = data.statusNavn
        caseStatus.statusType = data.statusType
        caseStatus.visStatus = Boolean(data.visStatus)

        return caseStatus
    }
}

export interface CaseApiData {
    reminder: ReminderData | null
    nyansat: NewlyHiredApiData
    sagStatus: CaseStatusApiData
    modtagetDato: string
    fristDato: string
    afsluttetSagsbehandlingsDato: string | null
    lovligOpdateringHandlingList: AllowedUpdateActionList[]
    sagsRegTid: string
    sagsId: string
    sagsNr: string
}

// "reminderDato": "2025-05-21",
// "sendReminderMail": false,
// "reminderId": "4639e907-9113-40a6-8482-e924fa986fe3",
// "reminderStatus": "Passiv",
// "indhold": "Kontakt nyansat\nfriktekst 2"
export type ReminderData = {
    reminderId: string
    indhold: string
    reminderStatus: string
    reminderDato: string
    sendReminderMail: boolean
}

export class Reminder {
    id = ''

    content = ''

    status = ''

    date = ''

    sendReminderMail = false

    static build(data: ReminderData): Reminder {
        const reminder = new Reminder()
        reminder.id = data.reminderId
        reminder.content = data.indhold
        reminder.status = data.reminderStatus
        reminder.date = data.reminderDato
        reminder.sendReminderMail = data.sendReminderMail

        return reminder
    }
}

export class Case {
    id = 0

    reminder: Reminder | undefined

    newlyHired: NewlyHired | undefined

    caseStatus: CaseStatus | undefined

    receivedDate = ''

    deadlineDate = ''

    caseId = ''

    caseNumber = ''

    caseRegistrationDate = ''

    caseClosedDate = ''

    allowedUpdateActionList: AllowedUpdateActionList[] = []

    searchable_caseId = ''

    searchable_name = ''

    searchable_position = ''

    searchable_workplace = ''

    searchable_caseNumber = ''

    static build(data: CaseApiData): Case {
        const newCase = new Case()

        newCase.reminder = data.reminder
            ? Reminder.build(data.reminder)
            : undefined
        newCase.newlyHired = NewlyHired.build(data.nyansat)
        newCase.caseStatus = CaseStatus.build(data.sagStatus)
        newCase.receivedDate = data.modtagetDato
        newCase.deadlineDate = data.fristDato
        newCase.caseId = data.sagsId
        newCase.caseNumber = data.sagsNr
        newCase.caseRegistrationDate = data.sagsRegTid
        newCase.caseClosedDate = data.afsluttetSagsbehandlingsDato
        newCase.searchable_caseId = data.sagsId
        newCase.searchable_caseNumber = data.sagsNr
        newCase.searchable_name = newCase.newlyHired?.name
        newCase.searchable_position = newCase.newlyHired?.position?.navn
        newCase.searchable_workplace = newCase.newlyHired?.workplace?.navn
        newCase.allowedUpdateActionList = data.lovligOpdateringHandlingList
        return newCase
    }

    static buildCaseFromCaseDetails(caseDetails: CaseDetail): Case {
        const newCase = new Case()
        newCase.caseId = caseDetails.caseId
        newCase.caseNumber = caseDetails.caseNumber
        newCase.caseRegistrationDate = caseDetails.caseRegistrationTime
        newCase.newlyHired = caseDetails.newlyHired
        newCase.caseStatus = caseDetails.caseStatus
        newCase.receivedDate = caseDetails.receivedDate
        return newCase
    }
}
